(function () {

    'use strict';

    if (typeof window === 'undefined') {

        dimensionsFn(
            module.exports,
            require('../../metric/metric.js'),
            require('../../metric/property.js'),
            require('../../metric/search.js'),
            require('../../../enums/metrics.js'),
            require('lodash')
        );

    } else {
        RivalIQ.module('models.metrics');

        dimensionsFn(
            RivalIQ.models.metrics,
            RivalIQ.metric,
            RivalIQ.metric.property,
            RivalIQ.metric.search,
            RivalIQ.enums,
            window._
        );
    }

    function dimensionsFn(metrics, metricFn, propertyFn, searchFn, metricEnums, _) {

        function wrap(metric) {
            const metricObj = metric;
            metric = _.extend({}, (metric.attributes ? metric.attributes : metric));
            const dimensions = metric.dimensions = _.clone(metric.dimensions || []);

            if (!_.includes(metric.dimensions, 'timeAnalysisMode') && _.isUndefined(metric.timeAnalysisMode)) {
                metric.timeAnalysisMode = metricEnums.timeAnalysisMode.MAIN_PERIOD;
                dimensions.unshift('timeAnalysisMode');
            }

            if (metric.channel && !_.includes(dimensions, 'channel')) {
                dimensions.unshift('channel');
            } else if (!metric.channel && metricObj.get && !_.isUndefined(metricObj.get('source'))) {
                // Set channel on metric obj if we have one available
                if (metricObj.get('source') !== metricEnums.sources.CROSS_CHANNEL) {
                    metric.channel = metricEnums.sourceDetails[metricObj.get('source')].channel;
                    metric.dimensions.unshift('channel');
                }
            }

            return metricFn(metric);
        }

        metrics.getProperty = function (metric, key, data, options) {
            const property = _.get(metric, 'unexpandedAttributes.property');

            if (property && !metric.over) {
                const overMetric = metricFn.build(metric.attributes, {
                    returns: property,
                    property: property
                });
                const result = getPropertyValue(wrap(overMetric), key, data, options);

                if (!_.isUndefined(result)) {
                    return result;
                }
            }

            return getPropertyResult(wrap(metric), key, data, options);
        };

        metrics.getDimensionProperty = function (metric, dimension, key, value, options) {
            return getDimensionPropertyResult(wrap(metric), dimension, key, value, options);
        };

        function getDimensionPropertyResult(metric, dimension, key, value, options) {
            dimension = dimension || _.last(metric.dimensions);

            let result = getDimensionResult(metric, key, dimension, value);

            if (!result) {
                result = searchFn.getDimensionDefault(key);
            }

            if (_.isFunction(result)) {
                return result(value, wrap(metric), options, dimension);
            }

            return result;
        }

        // Gets the defined values of a dimension. Useful for listing out
        // dimensions values in the UI without retrieving data or if dimension
        // values not in the data are desired
        metrics.dimensionValues = function (metric, dimension) {
            let values;

            const valuesFn = getDimensionResult(metric.attributes, 'dimensionValues', dimension);
            if (valuesFn) {
                values = valuesFn(undefined, metric);
            } else {
                values = _.keys(getDimensionResult(metric.attributes, 'value', dimension));
            }

            return _.filter(values, function (value) {
                return searchFn.isSpecified(metric.attributes, dimension, value);
            });
        };

        metrics._getProperty = function (key) {
            return propertyFn.get(key);
        };

        metrics._setProperty = function (key, value) {
            propertyFn.set(key, value);
        };

        metrics._getPropertyValue = getPropertyValue;
        function getPropertyValue(metric, key, data, options) {
            // NOTE historically channel was an optional dimension
            if (metric.channel && !_.includes(metric.dimensions, 'channel')) {
                metric = metricFn.build(metric, {
                    dimensions: ['channel']
                }, {
                    prependDimensions: true
                });
            }

            return searchFn.getPropertyValue(metric, key, data, options);
        }

        metrics._getDimensionResult = getDimensionResult;
        function getDimensionResult(metric, key, dimension, value) {
            // NOTE historically channel was an optional dimension
            if (metric.channel && !_.includes(metric.dimensions, 'channel')) {
                metric = metricFn.build(metric, {
                    dimensions: ['channel']
                }, {
                    prependDimensions: true
                });
            }

            return searchFn.getDimensionValue(metric, key, dimension, value);
        }

        function getPropertyResult(metric, key, data, options) {
            if (metric.returns === 'name' || (!metric.returns && metric.property === 'name')) {
                if (metric.over && (key === 'format' || key === 'csvFormat')) {
                    metric = metricFn.build(metric, {
                        dimensions: metric.over.dimensions
                    }, {
                        clobberDimensions: true
                    });
                    return getDimensionPropertyResult(metric, _.last(metric.dimensions), key, data, options);
                }

                const dimension = _.last(metricFn.getFreeDimensions(metric));
                if (dimension) {
                    return getDimensionPropertyResult(metric, dimension, key, data, options);
                }
            }

            return getPropertyValue(metric, key, data, options);
        }
    }
})();
